<template>
  <div class="request-dialog-style">
      <el-dialog
        title="Tips"
        :visible="requestDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="closeDialog(0)"
        :width="'500px'"
        >
        <p style="text-align: center;">The quotation has been updated. Do you want to continue?</p>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog(0)">CANCEL</el-button>
          <el-button type="primary" @click="closeDialog(1)">YES</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
  props: {
    requestDialog: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    closeDialog(type) {
      this.$emit('closeUpdateDialog', type);
    },
  },
}
</script>

<style lang="less">
.request-dialog-style {
  /deep/ .el-dialog {
    background: #FFFFFF;
    box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.25);
    border-radius: 10px;

    /deep/ .el-dialog__header {
      margin: 0 15px;
      padding: 10px 0;
      border-bottom: 1px solid #E6E6E6;
    }

    /deep/ .el-dialog__footer {
      padding: 0 20px 30px 20px;
    }

    /deep/ .el-icon-close {
      font-weight: bold;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #333333;
    }
   }

  .message-info {
    font-size: 14px;
    font-family: 'MicrosoftYaHei';
    text-align: center;
    color: #333333;
    line-height: 19px;
  }

  /deep/ .dialog-footer {
    display: flex;
    justify-content: center;

    .el-button {
      width: 109px;
      height: 30px;
      border-radius: 100px;
      font-size: 12px;
      line-height: 6px;
      font-family: 'MicrosoftYaHei';

    }

    .el-button--default {
      color: #004FB1;
      border: 1px solid #004FB1;
    }

    .el-button--primary {
      background: #004FB1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/myInfo/reuqestPriceUpdate.vue